// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1aO26","toolsTitle":"Header_toolsTitle__37ADX","toolsInfo":"Header_toolsInfo__1W2WH"};